import ReactDOM from 'react-dom/client';
import App from './defaultPages/App';

import * as serviceWorker from './serviceWorker';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import './index.scss';
import { cometChatConfig } from './config';
import { Home } from './home';
import AnswerDecline from './defaultPages/AnswerDecline';
import { CometChatUIKit, UIKitSettingsBuilder } from '@cometchat/chat-uikit-react';

declare global {
  interface Window { flutter_inappwebview: any; }
}

const UIKitSettings = new UIKitSettingsBuilder()
      .setAppId(`${cometChatConfig.appID}`)
      .setRegion(`${cometChatConfig.region}`)
      .setAuthKey(`${cometChatConfig.authKey}`)
      .subscribePresenceForAllUsers()
      .build();

CometChatUIKit.init(UIKitSettings)!
  .then(() => {
    const container = document.getElementById('root');
    if (container) {
      const root = ReactDOM.createRoot(container);
      root.render(
        <BrowserRouter>
          <Routes>
            <Route path="/answer/:loggedInUserId/:otherUserId/:callSessionId" element={<AnswerDecline action="answer" />} />
            <Route path="/decline/:loggedInUserId/:otherUserId/:callSessionId" element={<AnswerDecline action="decline" />} />
            <Route path="/:loggedInUserId/:otherUserId/:callSessionId" element={<App />} />
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
      );
    }
  })
  .catch((error) => {
    console.log("Initialization failed with error:", error);
    window.flutter_inappwebview.callHandler('chatLink', 'call-ended');
  });

serviceWorker.unregister();
